<template>
    <li>
        <div class="title"><span>対象店舗</span></div>
        <div class="detail">
            <p>
                <span v-if="$store.state.register.form.net_shop == 0">実店舗・ECサイト両方可</span>
                <span v-if="$store.state.register.form.net_shop == 1">実店舗のみ可</span>
                <span v-if="$store.state.register.form.net_shop == 2">ECサイトのみ可</span>
                <span v-if="$store.state.register.form.net_shop == 3">POPUPのみ可</span>
                <span v-if="$store.state.register.form.net_shop == 4">卸無し</span>
            </p>
        </div>
    </li>
</template>

